import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';
import { print } from 'graphql';

function persistedQuery(url: string) {
  const httpLink = new HttpLink({ uri: url });
  const linkChain = createPersistedQueryLink({
    useGETForHashedQueries: true,
    generateHash: async (document) => {
      return await sha256(print(document));
    },
  }).concat(httpLink);
  return linkChain;
}

export default function apolloClient(uri: string, usePersistedQueries: boolean) {
  const apiUrl = usePersistedQueries === true ? persistedQuery(uri) : new HttpLink({ uri });

  return new ApolloClient({
    link: apiUrl,
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  });
}
